module.exports = __webpack_public_path__ + "static/media/givemycertificate.548cb7f6.png";